export class CorrelationConstants {
    public static CorrelationHeaaderName: string = "X-CorrelationId";
    public static CorrelationSchemaAttribute: string = "XCV";
    public static SubCorrelationHeaderName: string = "Sub-CorrelationId";
    public static SubCorrelationSchemaAttribute: string = "SubXCV";
}